import prodEnvConfig from '@common/Assets/prodEnvConfigs.json';
import { initializeEnvConst } from 'aster-foundation/core/common/utils/ApiConst';
import MainCacheManager from 'aster-foundation/core/common/utils/ENVConfig/MainCacheManager';
import { isEmpty } from '@common/Utility/common-utils';

const envMapping = {
  'PROD-F': 'prod',
  'PREPROD-F': 'preProd',
  'PRODKSA-F': 'prodKsa'
};

// eslint-disable-next-line import/prefer-default-export
export const loadProdConfigs = async (country = 'AE') => {
  const envType = envMapping[process.env.NEXT_PUBLIC_SENTRY_ENV] || null;
  const countryWiseConfig = prodEnvConfig?.[country]?.[envType];

  if (isEmpty(countryWiseConfig)) return;

  await MainCacheManager.getInstance().initialize(countryWiseConfig);
  initializeEnvConst();
};
